<template>
  <div>
    <div class="mask" v-if="showAddModal">
      <div class="form-section message-modal">
        <h2 class="curr-step-title">{{ i18n.t('mbs-add') }}</h2>
        <div class="curr-step-desc">
          <span class="step-desc">{{ i18n.t('signup-step-1-desc') }}</span>
          <div class="quession-group">
            <img src="~img/icon-question.png" alt="question icon" class="icon-question" />
            <div class="quession">
              <p class="quession-title">{{ i18n.t('details') }}</p>
              <p class="quession-ctn">{{ i18n.t('whyVc') }}</p>
            </div>
          </div>
        </div>

        <!-- 表单组件部分 -->
        <!-- <restpwd-form
          v-bind="updateFormConfig"
          :formValue="formValue"
          :errMessage="errMessage"
          @changeFormValue="formValueChange"
        >
        </restpwd-form> -->
        <MembershipForm ref="restpwdForm" />

        <div class="term-desc">
          <div class="check-box" @click="toggleCheck">
            <img src="~img/icon-check.png" alt="checked icon" v-if="checked" />
          </div>
          <div class="desc">
            <p>
              {{ i18n.t('signup-checkbox-desc') }}
            </p>
            <p>
              <span class="desc-serial">1.</span>{{ i18n.t('signup-terms-desc-1') }} <br />
              <span class="desc-serial">2.</span>{{ i18n.t('signup-terms-desc-2') }}
            </p>
            <p>
              {{ i18n.t('see1') }}
              <a href="" target="_blank" class="tc-link">{{ i18n.t('signup-tnc') }}</a>
              {{ i18n.t('see2') }}
            </p>
          </div>
          <p v-if="showCheckedErr && !checked" class="show-errors">{{ i18n.t('errMsg1') }}</p>
        </div>
        <div class="btn-wrapper">
          <button class="dpi-button" @click="back">{{ i18n.t('cancel') }}</button>
          <button class="dpi-button dpi-button-primary" @click="vcesVerify">
            {{ i18n.t('continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { updateFormConfig } from './update.config';
  import restpwdForm from '@/components/BaseUi/Form/src';
  import verity from '@/utils/verify';
  // 解决获取不到$t的问题
  import i18n from '@/i18n/index';
  import { handleCreateSession } from '@/utils/createSession';
  // 解决获取不到$router的问题
  import router from '@/router';
  import store from '@/store';
  import { formatCardNo } from '@/components/BaseUi/Form/utils/index';
  // const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
  import { getQueryString, getDeviceId } from '@/utils';
  import request from '@/utils/request';
  import loading from '@/components/BaseUi/LoadingModal';
  import http from '@/services';
  import { mapMutations } from 'vuex';
  import MembershipForm from '@/components/MembershipForm/index.vue';
  import mdModal from '@/components/BaseUi/MessageModal/src';

  export default {
    name: 'AddCardModal',
    components: {
      restpwdForm,
      MembershipForm,
    },

    data() {
      return {
        i18n,
        updateFormConfig,
        checked: true,
        errMessage: [],
        showCheckedErr: '',
        showAddModal: false,
        cardHolderName: '',
        // cardData: {},
        formValue: {
          visaCardName: '',
          visaCardNum: '',
          cardExpiryDate: '',
          cardNum: '',
        },
        token: '',
        projectId: '',
        encryptCustomerInput: '',
        cardInfoToken: '',
        dpSessionId: '',
        pciPaymentToken: '',
        /* messageModalOptions: {
        image: false,
        descGroup: {
          desc1: 'mayHave',
          desc2: 'reEntering',
          subDesc: ['have1', 'have2', 'have3'],
        },
        confirmBtn: 'ok',
        justHide: true,
      }, */
      };
    },

    watch: {
      // 监听路由变化
      $route() {
        if (this.showAddModal) {
          // 如果弹窗显示中，隐藏弹窗
          this.hide();
        }
      },
      showAddModal(newVal) {
        if (newVal) {
          const payOrderNo = getQueryString('payOrderNo');
          const dpSessionId = localStorage.getItem('dpSessionId');
          if (payOrderNo) {
            loading.show();
            this.ingenico3DSNotify(payOrderNo, dpSessionId);
          }
        }
      },
    },

    methods: {
      show() {
        this.showAddModal = true;
      },
      hide() {
        this.showAddModal = false;
        this.formValue = {
          visaCardName: '',
          visaCardNum: '',
          cardExpiryDate: '',
          cardNum: '',
        };
        this.errMessage = [];
        this.checked = true;
      },

      // 获取到组件内修改后返回的数据
      formValueChange(data) {
        this.formValue = { ...this.formValue, ...data };
      },
      toggleCheck() {
        this.checked = !this.checked;
      },
      back() {
        this.hide();
        router.push('/');
      },
      vcesVerify() {
        verity(this.$refs.restpwdForm.modalValue).then(errMsg => {
          if (errMsg.pass && this.checked) {
            this.checkVcesVerify(this.$refs.restpwdForm.modalValue);
            this.errMessage = [];
          } else {
            if (!errMsg.pass) {
              // this.errMessage = errMsg;
              // 没过调用子组件自己的检验方法渲染错误信息
              this.$refs.restpwdForm.checkCard();
            }
            if (!this.checked) {
              this.showCheckedErr = true;
            } else {
              this.showCheckedErr = false;
            }
          }
        });
      },

      // 获取可用区域
      getAvailable(data) {
        loading.show();
        return http.login.getAvailable({ lang: data }).then(
          res => {
            if (res.state === '11') {
              res.payload.forEach(item => {
                if (item.regionCode === 'canada') {
                  this.projectId = item.projectId;
                }
                loading.hide();
              });
            } else {
              console.error(res.note);
              loading.hide();
            }
          },
          err => {
            console.error(err);
            loading.hide();
          },
        );
      },

      async checkVcesVerify(formValue) {
        try {
          const { cdeDate, visaCardNum } = formValue;

          await this.getAvailable(i18n.locale);
          loading.show();

          const res = await http.login.vcesVerify({
            channel: this.projectId,
            tokenCode: visaCardNum,
            expiryMonth: cdeDate.expiryMonth,
            expiryYear: cdeDate.expiryYear,
            lang: localStorage.getItem('lang'),
          });
          if (res?.state === '1') {
            this.token = res.result.id;
            // await this.checkCardNoStatus(this.token);
            // 获取支付渠道后判断走 checkout 或者 ingenico
            this.getPaymentChannel();
          } else if (res?.state === '00') {
            loading.hide();
            if (res?.note) {
              this.hide();
              mdModal.show({
                image: false,
                desc: res?.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
                callback: this.callbackFunc,
              });
            }
          }
        } catch (error) {
          console.error(error);
          loading.hide();
        }
      },
      // 获取支付渠道
      getPaymentChannel() {
        const params = {
          visaToken: this.token,
          source: 2,
          lang: this.$i18n.locale,
          deviceId: getDeviceId(),
        };
        http.login.getPaymentChannel(params).then(res => {
          if (res.state === '11') {
            const { paymentChannel, pciCacheCardInfoUrl, caller, dpSessionId } = res.data;
            this.dpSessionId = dpSessionId;
            if (paymentChannel === 106) {
              // ingenico
              this.ingenicoVerify();
            } else if (paymentChannel === 167) {
              // checkout
              this.checkoutVerify(pciCacheCardInfoUrl, caller);
            }
          } else {
            console.error(res.note);
          }
        });
      },
      ingenicoVerify() {
        const formValue = this.$refs.restpwdForm.modalValue;
        const { projectId } = this;
        handleCreateSession({ ...formValue, projectId }, this.checkCardInfo);
      },
      checkoutVerify(pciCacheCardInfoUrl, caller) {
        loading.show();
        const { cdeDate, visaCardName, visaCardNum, cardNum } = this.$refs.restpwdForm.modalValue;
        // 调用 pciCacheCardInfoUrl, 获取 paymentToken
        request({
          url: pciCacheCardInfoUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            caller,
          },
          data: {
            cardNumber: visaCardNum,
            cardHolderName: visaCardName,
            expireTime: cdeDate.expiryMonth + cdeDate.expiryYear,
            cvv: cardNum,
          },
        })
          .then(res => {
            if (res.state === '1') {
              this.pciPaymentToken = res.result?.token || '';
              this.checkCardInfo();
            } else {
              this.cardInfoErr = true;
              this.cardErrMsg = res.note;
              loading.hide();
            }
          })
          .catch(err => {
            console.log('checkout err', err);
            loading.hide();
          });
      },
      async checkCardInfo(paymentHash = '') {
        const { userId } = store.state.userInfo;
        this.encryptCustomerInput = paymentHash;
        const params = {
          visaToken: this.token,
          encryptCustomerInput: paymentHash,
          returnUrl: window.location.href,
          source: 2,
          lang: this.$i18n.locale,
          userId: userId || null,
          pciPaymentToken: this.pciPaymentToken,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
        };
        try {
          const res = await http.login.checkCardInfo(params);
          if (res.state === '11') {
            if (res.data.needThreeDS) {
              // 3ds 校验需要刷新页面
              store.commit('setState', {
                state: 'is3dsTriggeredReload',
                values: true,
              });
              // 跳转链接,跳转之前保存表单数据,用于回填
              localStorage.setItem('visaToken', this.token);
              localStorage.setItem('encryptCustomerInput', this.encryptCustomerInput);
              localStorage.setItem('dpSessionId', this.dpSessionId);
              localStorage.setItem('sourceModal', 'addCardModal');
              window.location.href = res.data.threeDSUrl;
            } else {
              this.cardInfoToken = res.data.cardInfoToken;
              // 信用卡是否被注册
              this.checkCardNoStatus();
            }
          } else {
            loading.hide();
            res?.note &&
              mdModal.show({
                image: false,
                desc: res.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
          }
        } catch (err) {
          loading.hide();
          console.log(err, 'checkCardInfo');
        }
      },
      async ingenico3DSNotify(payOrderNo, dpSessionId) {
        store.commit('setState', {
          state: 'is3dsTriggeredReload',
          values: false,
        });
        const params = {
          payOrderNo,
          dpSessionId,
          deviceUserAgent: navigator.userAgent,
          deviceLocale: this.$i18n.locale,
          source: 2,
        };
        try {
          const res = await http.login.ingenico3DSNotify(params);
          if (res.state === '11') {
            this.cardInfoToken = res.data.cardInfoToken;
            this.checkCardNoStatus();
          } else {
            loading.hide();
            res?.note &&
              mdModal.show({
                image: false,
                desc: res.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
          }
        } catch (err) {
          loading.hide();
          console.log(err, 'ingenico3DSNotify');
        }
      },
      async checkCardNoStatus() {
        try {
          const paymentHash =
            this.encryptCustomerInput || localStorage.getItem('encryptCustomerInput');
          const res = await http.login.checkCardNoStatus({
            token: this.token || localStorage.getItem('visaToken'),
            lang: localStorage.getItem('lang'),
          });
          if (res.state === '11') {
            this.$nextTick(() => {
              this.bindVisaCard(paymentHash);
            });
          } else if (res?.state === '00') {
            // this.hide();
            loading.hide();
            res?.note &&
              mdModal.show({
                image: false,
                desc: res?.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
                callback: this.callbackFunc,
              });
          }
        } catch (error) {
          console.error(error);
          loading.hide();
        }
      },
      bindVisaCard(paymentHash = '') {
        const { userId, sessionId } = store.state.userInfo;

        const data = {
          userId,
          token: this.token,
          encryptCustomerInput: paymentHash,
          lang: this.$i18n.locale,
          cardHolderName: this.cardHolderName,
          sessionId,
          cardInfoToken: this.cardInfoToken,
        };

        http.member
          .bindVisaCard(data)
          .then(res => {
            if (res?.state === '11') {
              const dragonCardData = {
                lang: i18n.locale,
                device: 'web',
                version: '1.0.0',
                userId,
                sessionId,
                // deviceName,
              };
              // 获取龙腾卡号
              this.getDragonCard(dragonCardData).then(res => {
                loading.hide();
                this.hide();
                store.commit('setState', {
                  state: 'isLogin',
                  values: true,
                });
                sessionStorage.setItem('isLogin', true);
                store.commit('setState', {
                  state: 'isIngenicoUpdatePending',
                  values: false,
                });

                const { bankLogo, bankLogoThumbnails, englishName, dragoncode, validDate } =
                  res.card;
                const [year, month, day] = validDate.split('-');
                const formatValidData = `${day}/${month}/${year}`;
                const formatDragoncode = formatCardNo(dragoncode);

                sessionStorage.setItem(
                  'addCardData',
                  JSON.stringify({
                    bankLogo,
                    bankLogoThumbnails,
                    englishName,
                    dragoncode: formatDragoncode,
                    validData: formatValidData,
                  }),
                );
                router.push({
                  path: '/addCardSuccess',
                });
              });
            } else if (res.state === '00' && res?.errorCode === 'visa.card.ingenico.fail') {
              loading.hide();
              this.hide();
              mdModal.show({
                image: false,
                descGroup: {
                  desc1: 'mayHave',
                  desc2: 'reEntering',
                  subDesc: ['have1', 'have2', 'have3'],
                },
                confirmBtn: 'ok',
                justHide: true,
              });
            } else if (res.state === '00') {
              loading.hide();
              if (res?.note) {
                this.hide();
                mdModal.show({
                  image: false,
                  desc: res?.note,
                  i18nNeed: false,
                  closeIcon: true,
                  confirmBtn: 'ok',
                  justHide: true,
                  callback: this.callbackFunc,
                });
              }
            }
          })
          .catch(error => {
            console.error(error);
            loading.hide();
          });
      },

      // 获取龙腾卡信息
      getDragonCard(data) {
        return new Promise(resolve => {
          http.login.getDragonCard(data).then(
            res => {
              if (res.state === '11') {
                resolve(res);
              } else if (res.state === '00') {
                res?.note && this.showMessageModal({ key: res.note, i18nNeed: false });
              }
            },
            err => {
              console.error(err);
              loading.hide();
            },
          );
        });
      },
      // 消息(message)弹窗关闭后的事件回调
      callbackFunc() {
        this.show();
      },
      ...mapMutations(['showMessageModal']),
    },
  };
</script>

<style lang="scss" scoped>
  @import './updateModal.scss';
  @import './updateModalMobile.scss';
</style>
